import * as React from "react";
import { DealsDebugProps } from "components/flexComponents/Deals/typings";

export const DealsDebugInfo = (props: DealsDebugProps) => {
  const { errorMessage, data, campaignId } = props;

  return (
    <div className="all-y-padding-two" data-testid="deals-debug-info">
      <div data-testid="deals-debug-info-campaign-id">
        <strong>Campaign ID:</strong> {campaignId ?? "Not available."}
      </div>
      {errorMessage && (
        <div data-testid="deals-debug-info-error-message">
          <strong>Error Message:</strong> {errorMessage}
        </div>
      )}
      {data?.campaignRecommendations?.campaigns[0]?.offers && (
        <div data-testid="deals-debug-offer-count">
          <strong>Offer/Destination count:</strong> {data?.campaignRecommendations?.campaigns[0]?.offers?.length}
        </div>
      )}
    </div>
  );
};
